import { InlineEditableField } from 'app/components/Common/EditPage/InlineEditableField';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { editableFields } from '../../editUtils';
import {
  selectEditableData,
} from '../../../../../../store/redux-store/placement-details/selectors';
import { CustomTextField } from '../CustomComponents/CustomTextField';
import { pageAttributesActions } from '../store/placementPageAttributes.redux';
import { selectEditStatus, selectPageAttributes } from '../store/placementPageAttributes.selector';
import { ActionAccessorHook } from './ActionAccessorHook';
import { missingField } from 'app/constants';
import { IVmsReqDetails } from 'app/models/Placement/PlacementDetails';
import { convertDateToPST } from 'app/helpers/dateHelper';

export const VmsReqNumber = ({ id }) => {
  const dispatch = useDispatch();
  const { control } = useFormContext();
  const { vmsReqNumber: status } = useSelector(selectEditStatus);
  const { editOrderStack } = useSelector(selectPageAttributes);
  const { vmsReqNo: defaultValue } = useSelector(selectEditableData);

   /** Code: useWatch has been used to retain value while avoidParentForm is triggered in Placement screen wrapper */
  const vmsReqNo = useWatch<string>({ name: 'vmsReqNo', control });

  const undoChecker = () => !editOrderStack.some(key => key === 'vmsReqNo');

  return (
      <div>
        <Controller
          control={control}
          name="vmsReqNo"
          render={({ field: { onChange, ...rest } }) => (
            <>
              {/** Component is used to access inaccessible methods from react-hook-form Controller
               * to invoke actions - say undo action */}
              <ActionAccessorHook
                actionChecker={undoChecker}
                accessAction={() => onChange(defaultValue)}
                hookDependancies={[editOrderStack]}
              />

              <InlineEditableField
                {...rest}
                id={id}
                label={vmsReqNo}
                inputProps={{
                  value: vmsReqNo,
                  minWidth: 80,
                  maxLength: 255,
                  renderedFromInlineEditor: true
                }}
                Control={CustomTextField}
                onChange={newValue => {
                  onChange(newValue);
                  dispatch(pageAttributesActions.pushToEditOrderStack(editableFields.vmsReqNo));
                }}
                setCurrentFocus={state => dispatch(pageAttributesActions.setCurrentFocus(state !== null ? id : null))}
                overflowTooltip={true}
                {...status}
              />
            </>
          )}
        />
      </div>
  );
};
interface ITooltipVmsDetailsPropTypes {
  vmsReqDetails: IVmsReqDetails;
}
export const TooltipVmsDetails = ({ vmsReqDetails: { lastUpdated, lastUpdatedBy } }: ITooltipVmsDetailsPropTypes) => {
  const { t } = useTranslation();
  return (
    <div>
      <span>
        {t('placement.common.lastUpdatedBy')} {lastUpdatedBy ? lastUpdatedBy : missingField}
      </span>
      <br />
      <span>
        {t('placement.common.lastUpdated')} {lastUpdated ? convertDateToPST(lastUpdated, 'MM/DD/YYYY h:mm A') : missingField}
      </span>
    </div>
  );
};
